// src/components/Outward.jsx
import React, { useState, useRef, useEffect } from "react";
import "../styles/layout.css";
import ReusableHeader from "./ReusableHeader";
import CustomButton from "./CustomButton";
import CustomTextField from "./CustomTextField";
import QRScanner from "./QRBarcodeScanner";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDeviceApi } from "../api/device";
import { decodeJwt } from "../util/decodeJwt";
import CustomListing from "./CustomListing";
import { useUsersApi } from "../api/users";
import CustomDropdown from "./CustomDropdown";
import { useOrderApi } from "../api/orders";
import UserCreateOrUpdateWidget from "./UserCreateOrUpdateWidget";
import OrganizationCreateDialog from "./OrganizationCreateDialog";
import { useParams, useNavigate } from "react-router-dom";
import { registerVendorUser, updateVendorUser, getVendorUserById } from "../api/users";
import { Pencil } from "lucide-react";
import { useDirectCustomerApi } from "../api/direct_customers";
import { validatePassword, validatePhoneNumber } from "../util/validation";
import { BrowserMultiFormatReader } from "@zxing/browser";

export default function Outward() {
  const  { checkVendorDeviceExists }  = useDeviceApi();
  const { createOrderWithDevices } = useOrderApi()
  const { registerVendorUser} = useUsersApi()
  const { createDirectCustomer } = useDirectCustomerApi();

  const {getAllRecipient} = useUsersApi()
  const { getAllVendorDevices, }=useDeviceApi()
  const [manufacturerId, setManufacturerId] = useState("");
  const [selectedDevices, setSelectedDevices] = useState({}); // key: _id, value: { modelId, count }
  const [selectedIds, setSelectedIds] = useState([]); // controlled checkbox keys
  const [showScanner, setShowScanner] = useState(false);
  const [loggedInUserId, setLoggedInUserId] = useState("");
  const [organizationId, setOrganizationId] = useState("");
  const [recipientGroups, setRecipientGroups] = useState([]); // ✅ For dropdown 1
  const [selectedGroup, setSelectedGroup] = useState(""); // ✅ Selected path
  const [recipientOptions, setRecipientOptions] = useState([]); // ✅ For dropdown 2
  const [selectedRecipient, setSelectedRecipient] = useState(null);
  const handleOrgDialogOpen = () => setIsOrgDialogOpen(true);
  const [isOrgDialogOpen, setIsOrgDialogOpen] = useState(false);
  const handleOrgDialogClose = () => setIsOrgDialogOpen(false);

  const fileInputRef = useRef(null);
  const [rows, setRows] = useState([]);
  const [orgOptions, setOrgOptions] = useState([]);
  const [currentUserRole, setCurrentUserRole] = useState("");
  const [loading, setLoading] = useState(false);

  const [editUserId, setEditUserId] = useState(null);
  const [isEditUserOpen, setIsEditUserOpen] = useState(false);

const [isManufacturerDialogOpen, setIsManufacturerDialogOpen] = useState(false);
const [activeDevice, setActiveDevice] = useState(null);
const [tempManufacturerId, setTempManufacturerId] = useState("");
const [tempMacAddress, setTempMacAddress] = useState("");

const [showDialogScanner, setShowDialogScanner] = useState(false);
const [scanTargetField, setScanTargetField] = useState(""); 
const barcodeReader = useRef(new BrowserMultiFormatReader());
// "mac" or "manufacturer"
  const navigate = useNavigate();


  //User creation
    const [formData, setFormData] = useState({
      name: "",
      phoneNumber: "",
      password: "",
      role: "",
      address: "",
      organizationId: "",
    });

  // Load user info from token
  useEffect(() => {
    debugger
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = decodeJwt(token);
      setLoggedInUserId(decoded?._id || "Unknown User");
      setOrganizationId(decoded?.organizationId || "Unknown Org");
      setCurrentUserRole(decoded?.role?.toLowerCase() || ""); // store role in lowercase

      // Load recipients
      loadRecipients(decoded?._id);
    }
  }, []);


    // When group changes, populate recipient list
    useEffect(() => {
    if (!selectedGroup) {
      setRecipientOptions([]);
      setSelectedRecipient(null);
      return;
    }

    const groupData = recipientGroups.find(
      (g) => g.value === selectedGroup
    );

    if (groupData) {
      const opts = groupData.data.map((obj) => ({
        label: `${obj.name} (${obj.phoneNumber || obj.email || obj._id})`,
        value: obj._id,
        obj,
      }));

      setRecipientOptions(opts);

      // // 🔥 AUTO SELECT FIRST RECIPIENT
      // if (opts.length) {
      //   setSelectedRecipient(opts[0].obj);
      // }
    }
  }, [selectedGroup, recipientGroups]);

  // Sync selectedIds whenever selectedDevices changes
  useEffect(() => {
    setSelectedIds(Object.keys(selectedDevices));
  }, [selectedDevices]);

  useEffect(() => {
  if (
    formData.name ||
    formData.phoneNumber ||
    formData.role
  ) {
    setSelectedRecipient(null);
    setSelectedGroup("");
  }
}, [formData]);

// Format MAC address → AA:BB:CC:DD:EE:FF
const formatMacAddress = (value) => {
  // remove all non-hex characters
  let cleaned = value.replace(/[^a-fA-F0-9]/g, "");

  // limit to 12 characters
  cleaned = cleaned.substring(0, 12);

  // add colon after every 2 chars
  const pairs = cleaned.match(/.{1,2}/g);

  return pairs ? pairs.join(":").toUpperCase() : "";
};

  // Add device manually or via QR
  const addDevice = (_id, modelId, source) => {
    if (!modelId || modelId.trim() === "") {
      toast.error("Manufacturer ID cannot be empty");
      return;
    }

    setSelectedDevices((prev) => {
      const updated = { ...prev };
      if (updated[_id]) {
        updated[_id].count += 1;
      } else {
        updated[_id] = { modelId, count: 1 };
      }
      return updated;
    });

    toast.success(`${source}: ${modelId}`);
  };

  const handleDialogScanDetected = (data) => {
  try {
    let text = String(data).trim();

    if (!text) {
      toast.error("Invalid QR/Barcode");
      return;
    }

    if (scanTargetField === "mac") {
      setTempMacAddress(formatMacAddress(text));
    }

    if (scanTargetField === "manufacturer") {
      text = text.replace(/\s/g, "");
      text = text.replace(/[^a-zA-Z0-9]/g, "");
      text = text.slice(0, 8);

      setTempManufacturerId(text);
    }

  } catch {
    toast.error("Failed to read code");
  }

  setShowDialogScanner(false);
};

    // ✅ Validate MAC format → AA:BB:CC:DD:EE:FF
  const isValidMacAddress = (mac) => {
    const macRegex = /^([0-9A-F]{2}:){5}[0-9A-F]{2}$/i;
    return macRegex.test(mac);
  };

  const handleDialogFileChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  try {
    const reader = barcodeReader.current;

    const img = document.createElement("img");
    img.src = URL.createObjectURL(file);

    await new Promise((resolve) => (img.onload = resolve));

    const result = await reader.decodeFromImageElement(img);
    let text = result?.text?.trim();

    if (!text) {
      toast.error("Invalid QR/Barcode image");
      return;
    }

    // -----------------------------
    // MAC ADDRESS TARGET
    // -----------------------------
    if (scanTargetField === "mac") {
      const formatted = formatMacAddress(text);

      if (!formatted) {
        toast.error("Invalid MAC format");
        return;
      }

      setTempMacAddress(formatted);
    }

    // -----------------------------
    // MACHINE SERIAL TARGET
    // -----------------------------
    if (scanTargetField === "manufacturer") {
      text = text.replace(/\s/g, "");
      text = text.replace(/[^a-zA-Z0-9]/g, "");
      text = text.slice(0, 8);

      setTempManufacturerId(text);
    }

    toast.success("Code detected");

  } catch (err) {
    toast.error("Unreadable QR/Barcode image");
  }

  e.target.value = "";
};

  // Fetch recipients from API
const loadRecipients = async () => {
  debugger
  try {
      const token = localStorage.getItem("token");
      let currentUserRole ="";
    if (token) {
      const decoded = decodeJwt(token);
      currentUserRole = decoded?.role?.toLowerCase() || "";
    }
    const res = await getAllRecipient();

    if (res.success && res.recipients) {

      // hierarchy order
      const roleOrder = [
        "manufacturer",
        "distributor",
        "dealer",
        "customer",
      ];

      const allGroups = [
        {
          label: "Manufacturers",
          value: "manufacturers",
          role: "manufacturer",
          data: res.recipients.manufacturers || [],
        },
        {
          label: "Distributors",
          value: "distributors",
          role: "distributor",
          data: res.recipients.distributors || [],
        },
        {
          label: "Dealers",
          value: "dealers",
          role: "dealer",
          data: res.recipients.dealers || [],
        },
        {
          label: "Customers",
          value: "customers",
          role: "customer",
          data: res.recipients.customers || [],
        },
      ];

    let filteredGroups = allGroups;

    // 🔥 ADMIN → only manufacturers
    if (currentUserRole === "admin") {
      filteredGroups = allGroups.filter(
        (g) => g.role === "manufacturer"
      );
    }

    // 🔥 Others → only levels BELOW current user
    else if (currentUserRole && roleOrder.includes(currentUserRole)) {
      const myIndex = roleOrder.indexOf(currentUserRole);

      filteredGroups = allGroups.filter(
        (g) => roleOrder.indexOf(g.role) > myIndex
      );
    }

    setRecipientGroups(filteredGroups);
    }
  } catch (err) {
    toast.error(err.message || "Failed to load recipients");
  }
};

useEffect(() => {
  if (recipientGroups.length && !selectedGroup) {
    // ✅ AUTO SELECT FIRST GROUP
    setSelectedGroup(recipientGroups[0].value);
  }
}, [recipientGroups]);


  const handleAddClick = () => {
    addDevice(manufacturerId, manufacturerId, "Manual Entry");
    setManufacturerId("");
  };

  // Remove one count or delete completely if count = 1
  const handleRemoveClick = (_id) => {
    const newSelected = {};

    Object.entries(selectedDevices).forEach(([key, item]) => {
      if (key === _id) {
        if (item.count > 1) {
          newSelected[key] = { modelId: item.modelId, count: item.count - 1 };
        }
        // else: skip to remove completely
      } else {
        newSelected[key] = { ...item };
      }
    });

    setSelectedDevices(newSelected); // triggers useEffect to update selectedIds
    toast.info(`Removed: ${_id}`);
  };

const handleScanDetected = (data) => {
  debugger
  try {
    const text = String(data).trim();

    /**
     * QR contains plain text like:
     * 1234AX109876543211234567891
     *
     * We only want the Manufacturer ID part
     * Example rule: first 8–10 alphanumeric chars
     */

    if (!text) {
      toast.error("Invalid QR data");
      return;
    }

    setManufacturerId(text);
  } catch (err) {
    toast.error("Failed to read QR code");
  }

  setShowScanner(false);
};


const handleFileChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  try {
    const reader = barcodeReader.current;

    const img = document.createElement("img");
    img.src = URL.createObjectURL(file);

    await new Promise((resolve) => (img.onload = resolve));

    const result = await reader.decodeFromImageElement(img);
    const text = result?.text?.trim();

    if (!text) {
      toast.error("Invalid QR/Barcode image");
      return;
    }

    setManufacturerId(text);

  } catch {
    toast.error("Unreadable QR/Barcode image");
  }

  e.target.value = "";
};

  const openManufacturerDialog = (device) => {
    setActiveDevice(device);

    setTempManufacturerId(device.manufacturerId || "");
    setTempMacAddress(device.macAddress || "");

    setIsManufacturerDialogOpen(true);
  };

const closeManufacturerDialog = () => {
  // close dialog
  setIsManufacturerDialogOpen(false);

  // reset device
  setActiveDevice(null);

  // clear values
  setTempManufacturerId("");
  setTempMacAddress("");

  // close scanner if open
  setShowDialogScanner(false);

  // reset scan target
  setScanTargetField("");

  // clear uploaded file
  if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
};

const saveManufacturerMapping = async () => {
    // required check
    if (!tempManufacturerId.trim() || !tempMacAddress.trim()) {
      toast.error("MAC Address and Machine Serial Number are required");
      return;
    }

    // ⭐ MAC FORMAT VALIDATION
    if (!isValidMacAddress(tempMacAddress.trim())) {
      toast.error("Invalid MAC Address format. Use AA:BB:CC:DD:EE:FF");
      return;
    }

    // machine serial validation
    if (tempManufacturerId.trim().length !== 8) {
      toast.error("Machine Serial Number must be exactly 8 characters");
      return;
    }

  try {
    const res = await checkVendorDeviceExists({
      manufacturerId: tempManufacturerId.trim(),
      macAddress: tempMacAddress.trim(),
    });

    if (res?.exists) {
      toast.error(res?.message || "Device already exists");
      return;
    }

    setSelectedDevices((prev) => ({
      ...prev,
      [activeDevice._id]: {
        ...prev[activeDevice._id],
        manufacturerId: tempManufacturerId.trim(),
        macAddress: tempMacAddress.trim(),
      },
    }));

    toast.success("Machine Serial Number mapped successfully");
    closeManufacturerDialog();

  } catch (err) {
    toast.error(
      err?.response?.data?.message ||
      err.message ||
      "Failed to validate manufacturer ID"
    );
  }
};

const handleOutwardClick = async () => {
  debugger;

  const deviceMappings = Object.entries(selectedDevices).map(([key, item]) => ({
    deviceId: item._id,
    manufacturerId: item.manufacturerId,
    macAddress: item.macAddress,   // 👈 ADD THIS
  }));

  if (!deviceMappings.length) {
    toast.error("Please add at least one device.");
    return;
  }

  // 🔥 Manufacturer must map ID — others can proceed
// 🔥 Manufacturer must map BOTH MAC & Manufacturer ID
    if (currentUserRole === "manufacturer") {
      const missing = Object.values(selectedDevices).find(
        (d) =>
          !d.manufacturerId ||
          !d.manufacturerId.trim() ||
          !d.macAddress ||
          !d.macAddress.trim()
      );

      if (missing) {
        toast.error(
          "Please map both MAC Address and Manufacturer ID for all selected devices"
        );
        return;
      }
    }
  

  try {
    setLoading(true);

    let finalRecipient = selectedRecipient;

    // ----------------------------------
    // ✅ CREATE USER FIRST (IF FORM FILLED)
    // ----------------------------------
if (
  !selectedRecipient &&
  (
    formData.name ||
    formData.phoneNumber ||
    formData.password ||
    formData.role ||
    formData.address
  )
) {
  if (!validateCreateUserForm()) return;

      let userRes = {};
      if(formData.role=="customer"){
      userRes = await createDirectCustomer(formData);
      }else{
      userRes = await registerVendorUser(formData);

      }
      toast.success("User registered successfully!");

      finalRecipient = userRes.data;

      // 🔥 auto-select newly created user
      const groupKey =
        finalRecipient.role === "distributor"
          ? "distributors"
          : finalRecipient.role === "dealer"
          ? "dealers"
          : "customers";

      setSelectedGroup(groupKey);

      // wait for dropdown options refresh
      await loadRecipients();

      setTimeout(() => {
        setSelectedRecipient(finalRecipient);
      }, 300);

      // reset form
      setFormData({
        name: "",
        phoneNumber: "",
        password: "",
        role: "",
        address: "",
        organizationId: "",
      });
    }

    if (!finalRecipient) {
      toast.error("Please select or create a recipient.");
      return;
    }

    // ----------------------------------
    // ✅ PREPARE OUTWARD PAYLOAD
    // ----------------------------------
  const payload = {
    fromOrganizationId: organizationId,
    status: "pending",
    deviceMappings,   // 👈 SEND THIS
    createdBy: loggedInUserId,
  };

    const toOrgId =
      finalRecipient.organizationId ||
      finalRecipient.organization?._id ||
      null;

    if (toOrgId) {
      payload.toOrganizationId = toOrgId;
    }

    if (finalRecipient._id) {
      payload.toUserId = finalRecipient._id;
    }

    console.log("Final Outward Payload:", payload);
    
    // ----------------------------------
    // ✅ CALL OUTWARD API
    // ----------------------------------
    const outwardRes = await createOrderWithDevices(payload);

    toast.success(outwardRes.message || "Outward successful!");

    setSelectedDevices({});
    setSelectedGroup("");
    setSelectedRecipient(null);
      // Reload after 1.5 seconds
      setTimeout(() => {
        window.location.reload();
      }, 1500);
  } catch (err) {
    console.error(err);
    toast.error(err.message || "Failed to outward devices");
  } finally {
    setLoading(false);
  }
};

const handleSelectionChange = ({ updatedIds, selectedItems }) => {
  const updated = {};

  selectedItems.forEach((item) => {
    if (!item._id) return;

    // ✅ Checkbox means selected ONCE
    updated[item._id] = {
      _id: item._id,
      manufacturerId: item.manufacturerId,
      macAddress: item.macAddress,
      count: 1, // 🔒 ALWAYS 1
    };
  });

  setSelectedDevices(updated);
  setSelectedIds(updatedIds);
};



  // Columns for CustomListing
  const columns = [
    {
      key: "serialNumber",
      label: "BCU Serial Number",
      render: (row) => row.serialNumber ?? "N/A" ,
    },
    {
      key: "manufacturerId",
      label: "Machine Serial Number",
      render: (row) => row.manufacturerId==undefined? "N/A": (row.manufacturerId!=""?  row.manufacturerId : "N/A") ,
    },
    {
      key: "macAddress",
      label: "Mac Address",
      render: (row) => row.macAddress==undefined? "N/A": (row.macAddress!=""?  row.macAddress : "N/A"),
    },
  ];


  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleOrgCreated = (newOrg) => {
    // Update orgOptions with newly created org
    setOrgOptions((prev) => [...prev, { value: newOrg._id, label: newOrg.name }]);
    // Auto-select the new org
    setFormData((prev) => ({ ...prev, organizationId: newOrg._id }));
    setIsOrgDialogOpen(false);
  };


  // Role dropdown options based on logged user role
  const getRoleOptions = () => {
    debugger
    switch (currentUserRole) {
      case "admin":
        return [
          { value: "manufacturer", label: "Manufacturer" }
        ];
      case "manufacturer":
        return [
          { value: "distributor", label: "Distributor" },
          { value: "dealer", label: "Dealer" },
          { value: "customer", label: "Customer" }
        ];
      case "distributor":
        return [
          { value: "dealer", label: "Dealer" },
          { value: "customer", label: "Customer" }
        ];
      case "dealer":
        return [{ value: "customer", label: "Customer" }];
      default:
        return [];
    }
  };

  const handleSubmit = async () => {
    // Validate required fields
    if (!formData.name || !formData.phoneNumber || !formData.organizationId) {
      toast.warn("Please fill in all required fields including Organization");
      return;
    }

    try {
      setLoading(true);
      let result;

      result = await registerVendorUser(formData);
      toast.success("User registered successfully!");
      

      //if (onSubmit) onSubmit(result.data || formData);
      navigate("/users");
    } catch (err) {
      console.error(err);
      toast.error(err.message || "Operation failed");
    } finally {
      setLoading(false);
    }
  };

  const validateCreateUserForm = () => {
  // NAME
  if (!formData.name?.trim()) {
    toast.error("Name is required");
    return false;
  }

  // PHONE
  if (!formData.phoneNumber?.trim()) {
    toast.error("Phone number is required");
    return false;
  }

  if (!validatePhoneNumber(formData.phoneNumber)) {
    toast.error("Phone number must be 10 digits");
    return false;
  }

  // PASSWORD
  if (!formData.password?.trim()) {
    toast.error("Password is required");
    return false;
  }

  if (!validatePassword(formData.password)) {
    toast.error(
      "Password must be 8+ chars with letter & number"
    );
    return false;
  }

  // ROLE
  if (!formData.role) {
    toast.error("Role is required");
    return false;
  }

  // ADDRESS
  if (!formData.address?.trim()) {
    toast.error("Address is required");
    return false;
  }

  return true;
};

  return (
    <div className="inventoryManagement">
      <ReusableHeader title="Device Outward" />

      <div className="outward-container">
        {/* Left Column */}
        <div className="left-column">
          <div className="box">
            <div className="box-label">In Stock Devices</div>
            <div className="added-devices-container">
              <CustomListing
                data={rows}         // controlled rows
                 setData={setRows}   // setter to update table instantly
                fetchData={getAllVendorDevices}
                columns={columns}
                pageSize={10}
                tableWidth="100%"
                headerTrClass="outward-header-row"
                headerThClass="outward-th-cell"
                thClass="outward-th-cell"
                tdClass="outward-td-cell"
                paginationClass="outward-pagination-footer"
                onSelectionChange={handleSelectionChange}
                selectedKeys={selectedIds} // controlled checkboxes
              />
            </div>
          </div>

          <div className="box">
            <div className="box-label">Selected Devices</div>
           <div className="added-devices-container">
              {selectedIds.length === 0 ? (
                <p className="no-device-text">No devices selected</p>
              ) : (
             <div className="device-list">
              {Object.entries(selectedDevices).map(([key, item]) => (
                <div
                  key={key}
                  className="device-card-horizontal"
                  onClick={() =>
                    currentUserRole === "manufacturer" &&
                    openManufacturerDialog(item)
                  }
                >
                  {/* LEFT SIDE */}
               <div className="device-left">

                  {/* ================= ADMIN VIEW ================= */}
                  {currentUserRole === "admin" && (
                    <div className="mac-text">
                      BCU Serial Number:{" "}
                      <strong>{item._id}</strong>
                    </div>
                  )}

                 {/* ================= MANUFACTURER VIEW ================= */}
                  {currentUserRole === "manufacturer" && (
                    <>
                      <div className="bcu-text">
                        BCU Serial Number: <strong>{item._id || "N/A"}</strong>
                      </div>

                      <div className="mac-text">
                        MAC:{" "}
                        <span className={!item.macAddress ? "missing" : "mapped"}>
                          {item.macAddress || "Not mapped"}
                        </span>
                      </div>

                      <div className="manufacturer-text">
                        Machine Serial Number:{" "}
                        <span className={!item.manufacturerId ? "missing" : "mapped"}>
                          {item.manufacturerId || "Not mapped"}
                        </span>
                      </div>
                    </>
                  )}

                  {/* ================= OTHER ROLES ================= */}
                  {currentUserRole !== "admin" &&
                    currentUserRole !== "manufacturer" && (
                      <>
                        <div className="mac-text">
                          MAC:{" "}
                          <span className={!item.macAddress ? "missing" : "mapped"}>
                            {item.macAddress || "Not mapped"}
                          </span>
                        </div>

                        <div className="manufacturer-text">
                          Machine Serial Number:{" "}
                          <span className={!item.manufacturerId ? "missing" : "mapped"}>
                            {item.manufacturerId || "Not mapped"}
                          </span>
                        </div>
                      </>
                  )}

                </div>
                  {/* RIGHT ACTIONS */}
                  <div className="device-actions">

                    {/* ✏️ Pencil only for manufacturer */}
                    {currentUserRole === "manufacturer" && (
                      <Pencil size={18} className="edit-icon" />
                    )}

                    {/* ❌ Remove ALWAYS visible */}
                    <button
                      className="remove-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemoveClick(key);
                      }}
                    >
                      ✕
                    </button>
                  </div>
                </div>
              ))}
            </div>
              )}
            </div>
          </div>
        </div>

       <div className="right-column">

      {/* ===== Box 1 : Select Recipient ===== */}
      <div className="box recipient-box">
  <div className="box-label">Select Recipient</div>

  {/* GROUP DROPDOWN */}
  <div className="recipient-row">
  <CustomDropdown
    className="recipient-input"
    value={selectedGroup}
    onChange={(val) => {
      setSelectedGroup(val);
      setSelectedRecipient(null); // ✅ reset selected user
      setRecipientOptions([]); // ✅ optional clean reset
    }}
      options={recipientGroups.map((g) => ({
        label: g.label,
        value: g.value,
      }))}
      isMultiSelect={false}
      disabled={
        formData.name ||
        formData.phoneNumber ||
        formData.role
      }
    />
  </div>

  {/* USER DROPDOWN + EDIT */}
<div className="recipient-row-wrapper">
  <div className="recipient-row">
    <CustomDropdown
      className="recipient-input"
      value={selectedRecipient?._id || ""}
      onChange={(val) => {
        const selectedObj = recipientOptions.find(
          (opt) => opt.value === val
        );
        setSelectedRecipient(selectedObj ? selectedObj.obj : null);
      }}
      options={recipientOptions.map((opt) => ({
        label: opt.label,
        value: opt.value,
      }))}
      disabled={
      !selectedGroup ||
      formData.name ||
      formData.phoneNumber ||
      formData.role
    }
      isMultiSelect={false}
    />

      {selectedRecipient?._id && (
      <button
        className="recipient-edit-btn"
        onClick={() => {
          setEditUserId(selectedRecipient._id);
          setIsEditUserOpen(true);
        }}
        title="Edit User"
        type="button"
      >
        <Pencil size={16} />
      </button>
    )}
  </div>
</div>
      </div>
    <div className="or-label">
    <span>OR</span>
    </div>
      {/* ===== Box 2 : OR + User Form ===== */}
      <div className="box user-box">

        <div className="or-divider">CREATE USER</div>

        <div className="user-form-card">
          <div className="user-columns">

            <div className="user-column-left">
              <CustomTextField
                label="Name"
                value={formData.name}
                onChange={(e) => handleChange("name", e.target.value)}
              />

              <CustomTextField
                label="Phone Number"
                value={formData.phoneNumber}
                onChange={(e) =>
                  handleChange("phoneNumber", e.target.value)
                }
              />

              <CustomTextField
                label="Password"
                type="password"
                value={formData.password}
                onChange={(e) =>
                  handleChange("password", e.target.value)
                }
              />
            </div>

            <div className="user-column-right">
              {isOrgDialogOpen && (
                <OrganizationCreateDialog
                  onClose={handleOrgDialogClose}
                  onCreate={handleOrgCreated}
                />
              )}

              <CustomDropdown
                label="Role"
                options={getRoleOptions()}
                value={formData.role}
                isMultiSelect={false}
                onChange={(value) =>
                  handleChange("role", value)
                }
              />

              <CustomTextField
                label="Address"
                value={formData.address}
                onChange={(e) =>
                  handleChange("address", e.target.value)
                }
              />

            </div>
          </div>
        </div>
      </div>

      {/* ===== Box 3 : Outward Button ===== */}
      <div className="box outward-box">
        <CustomButton className="btn-outward" onClick={handleOutwardClick}>
          Outward (
          {Object.values(selectedDevices).reduce(
            (acc, item) => acc + item.count,
            0
          )}
          )
        </CustomButton>
      </div>
      {currentUserRole === "manufacturer" &&
        isManufacturerDialogOpen &&
        activeDevice && (
        <div className="swap-overlay">
          <div className="swap-modal">

            <h3>Map Machine Serial Number</h3>
            {showDialogScanner && (
  <div className="dialog-scanner-wrapper">
    <QRScanner
      onDetected={handleDialogScanDetected}
      onClose={() => setShowDialogScanner(false)}
    />
  </div>
)}

          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleDialogFileChange}
          />

            <div className="swap-field">
            <label>MAC Address *</label>

            <input
              value={tempMacAddress}
              onChange={(e) =>
                setTempMacAddress(formatMacAddress(e.target.value))
              }
              placeholder="AA:BB:CC:DD:EE:FF"
              maxLength={17} // 12 chars + 5 colons
            />

            <div className="button-group">
              <div className="qr-action-group">
              {/* Scan Button */}
              <button
                className="qr-btn scan-btn"
                onClick={() => {
                  setScanTargetField("mac"); // or manufacturer
                  setShowDialogScanner(true);
                }}
              >
                Scan QR
              </button>

              {/* Upload Button */}
              <button
                className="qr-btn upload-btn"
                onClick={() => {
                  setScanTargetField("mac"); // or manufacturer
                  fileInputRef.current.click();
                }}
              >
                Upload QR
              </button>

            </div>
            </div>
          </div>

          <div className="swap-field">
            <label>Machine Serial Number</label>

            <input
              value={tempManufacturerId}
              maxLength={8}   // ✅ LIMIT 8 CHARACTERS
              onChange={(e) => {
                const value = e.target.value.replace(/\s/g, ""); // remove spaces
                setTempManufacturerId(value.slice(0, 8)); // enforce 8 limit
              }}
              placeholder="Enter Machine Serial Number (Max 8 chars)"
            />

            <div className="button-group">
             <div className="qr-action-group">

  {/* Scan Button */}
  <button
  className="qr-btn scan-btn"
  onClick={() => {
    setScanTargetField("manufacturer"); // ✅ FIX
    setShowDialogScanner(true);
  }}
>
  Scan QR
</button>

<button
  className="qr-btn upload-btn"
  onClick={() => {
    setScanTargetField("manufacturer"); // ✅ FIX
    fileInputRef.current.click();
  }}
>
  Upload QR
</button>

</div>
            </div>
          </div>

            <div className="map-actions">
              <button
                className="map-btn cancel-btn"
                onClick={closeManufacturerDialog}
              >
                Cancel
              </button>

              <button
                className="map-btn save-btn"
                onClick={saveManufacturerMapping}
              >
                Save
              </button>
            </div>  
          </div>
        </div>
      )}

      {isEditUserOpen && (
  <div className="modal-overlay">
    <div className="modal-box large-modal">
      <UserCreateOrUpdateWidget
        userId={editUserId}
        userRole={selectedRecipient.role}
        onCancel={() => {
          setIsEditUserOpen(false);
          setEditUserId(null);
        }}
        onSubmit={() => {
          setIsEditUserOpen(false);
          setEditUserId(null);
          loadRecipients(); // refresh dropdown
        }}
      />
    </div>
  </div>
)}

        </div>
      </div>
    </div>
  );
}
